import { render, staticRenderFns } from "./EditPreOrderModal.vue?vue&type=template&id=22d61dd1&scoped=true"
import script from "./EditPreOrderModal.vue?vue&type=script&lang=js"
export * from "./EditPreOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d61dd1",
  null
  
)

export default component.exports